import React, { useState, useEffect } from "react";
import { withRouter } from '../../common/withRouter';
import * as Yup from "yup";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DataDefinitionList,
  EditableArea,
  Notification,
  Message,
  IconWithText,
  Loader,
  FormikInput,
  Tabs,
} from "../../web.common";
import { sentenceCase } from "change-case";
import withApi from "../higherOrderComponents/withApi";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import { Search } from "../misc/Search";
import { getApiErrorMessage } from "../../common/utils";
import { Divider, DetailsRightBar, NoLink, Link } from "./DetailsRightBar";
import { mappedFacilityTypes } from "../../enums/FacilityTypes";
import {
  DisplayGuid,
  DisplayDate,
  DisplayType,
  DisplayAddress,
} from "../items";
import { EditOpeningHours } from "./EditOpeningHours";
import ReactSelect from "react-select";
import ViewSwitch from "../misc/ViewSwitch";
import ResourceSplitsBoard from "./ResourceSplitsBoard";

const ResourceGroupInternal = ({
  api,
  match: {
    params: { id },
  },
  history,
}) => {
  const [data, setData] = useState(null);
  const [isEditingMain, doEditMain] = useState(null);
  const [isEditingResource, doEditResource] = useState(null);
  const [lockers, setlockers] = useState(null);
  const [splitsView, setSplitsView] = useState("new");

  useEffect(() => {
    async function loadFromApi() {
      const group = await api.resources.getResourceGroup(id);

      setData(group);

      if (group) {
        const lockersLoaded = await api.lockers.getLockersByFacilityId(group.group.facilityId);

        if (lockersLoaded != null) {
          setlockers(lockersLoaded.data.map((x) => ({ value: x.id, label: x.name })));
        }
      }
    }

    if (!data) {
      loadFromApi();
    }
  }, []);

  const getLockerName = (id) => {
    if (lockers == null) {
      return "loading...";
    }

    const lockerName = lockers
      .filter((x) => x.value == id)
      .map((x) => x.label)[0];

    return lockerName;
  };

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={"boh"} />
          <PageTop
            documentTitle={`Resource group page`}
            documentDescription={`Resource group page`}
          />
          {data ? (
            <React.Fragment>
              <br />
              <br />
              <br />
              <h3>Resource group</h3>
              {isEditingMain ? (
                <React.Fragment>
                  <label for="rg-name">Name: </label>
                  <input
                    name="rg-name"
                    id="rg-name"
                    value={isEditingMain.name}
                    onChange={({ target }) =>
                      doEditMain({
                        ...isEditingMain,
                        name: console.log(target.value) || target.value,
                      })
                    }
                  />
                  <label for="rg-facilityid">Facility Id</label>
                  <input
                    name="rg-facilityid"
                    id="rg-facilityid"
                    value={isEditingMain.facilityId}
                    onChange={({ target }) =>
                      doEditMain({
                        ...isEditingMain,
                        facilityId: console.log(target.value) || target.value,
                      })
                    }
                  />
                  <label for="rg-lockerId">Locker</label>
                  <ReactSelect
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix"
                    isClearable={true}
                    defaultValue={lockers.filter(
                      (x) => x.value == isEditingMain.lockerId
                    )}
                    onChange={(selection) =>
                      doEditMain({
                        ...isEditingMain,
                        lockerId: selection ? selection.value : undefined,
                      })
                    }
                    options={lockers}
                  ></ReactSelect>
                  <button
                    onClick={async () => {
                      try {
                        await api.resources.saveResourceGroup(isEditingMain);
                      } catch (error) {
                        alert(error?.message || "Unable to save the group");
                        return;
                      }
                      const group = await api.resources.getResourceGroup(id);
                      setData(group);
                      doEditMain(null);
                    }}
                  >
                    Save
                  </button>
                  <button
                    onClick={async () => {
                      doEditMain(null);
                    }}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : (
                <DataDefinitionList
                  listData={{
                    Id: data.group.id,
                    Name: data.group.name,
                    FacilityId: data.group.facilityId,
                    Locker: data.group.lockerId ? (
                      <>
                        {getLockerName(data.group.lockerId)} -{" "}
                        <DisplayGuid>{data.group.lockerId}</DisplayGuid>
                      </>
                    ) : (
                      ""
                    ),
                    CreatedAt: data.group.createdAt,
                    Action: (
                      <div>
                        <span
                          onClick={() => {
                            doEditMain(data.group);
                          }}
                        >
                          edit
                        </span>
                        <br />
                        <br />
                        <span
                          onClick={async () => {
                            if (
                              !confirm("are you sure to delete this group?")
                            ) {
                              return;
                            }
                            try {
                              await api.resources.removeGroup(id);
                            } catch (error) {
                              alert(error?.message || "Unable to delete the group");
                              return;
                            }
                            history.push("/");
                          }}
                        >
                          remove
                        </span>
                      </div>
                    ),
                  }}
                  classNames={["detail-page-list"]}
                />
              )}

              <br />
              <br />

              <ViewSwitch value={splitsView} onChange={setSplitsView} />
              {splitsView === "new" ? (
                <ResourceSplitsBoard
                  groupId={data.group.id}
                  groupName={data.group.name}
                  facilityId={data.productsFacilityId}
                  splits={data.relatedSplits}
                  onChanged={async () => setData(await api.resources.getResourceGroup(id))}
                />
              ) : (
              <>
              {data.relatedSplits.map((x, i) => (
                <React.Fragment>
                  <span>
                    Split {i + 1} - {x.id}
                  </span>
                  <span
                    style={{ float: "right" }}
                    onClick={async () => {
                      if (!confirm("are you sure to delete this split?")) {
                        return;
                      }
                      await api.resources.removeSplit(x.id);
                      const group = await api.resources.getResourceGroup(id);
                      setData(group);
                    }}
                  >
                    remove
                  </span>
                  {/* <DataDefinitionList
                      listData={x.relatedResources}
                      classNames={['detail-page-list']}
                      /> */}

                  <table className="data-lists component-data-table cell-content-align-top data-table-no-results">
                    <tr
                      style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}
                    >
                      <td>Id</td>
                      <td>Name</td>
                      <td>Product</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    {x.resources.map(
                      ({
                        name,
                        product: { productName },
                        id: resourceId,
                        resourceSplitId,
                        productId,
                      }) =>
                        (isEditingResource && isEditingResource.Id) ===
                        resourceId ? (
                          <tr style={{ backgroundColor: "#cbcbcb" }}>
                            <td>{resourceId}</td>
                            <td>
                              <input
                                name="resource-name"
                                id="resource-name"
                                value={isEditingResource.name}
                                onChange={({ target }) =>
                                  doEditResource({
                                    ...isEditingResource,
                                    name:
                                      console.log(target.value) || target.value,
                                  })
                                }
                              />
                            </td>
                            <td>
                              <input
                                name="resource-facilityid"
                                id="resource-facilityid"
                                value={isEditingResource.productId}
                                onChange={({ target }) =>
                                  doEditResource({
                                    ...isEditingResource,
                                    productId:
                                      console.log(target.value) || target.value,
                                  })
                                }
                              />
                            </td>
                            <td></td>
                            <td
                              onClick={async () => {
                                doEditResource(null);
                              }}
                            >
                              cancel
                            </td>
                            <td
                              onClick={async () => {
                                try {
                                  await api.resources.saveResource({
                                    Id: resourceId,
                                    name: isEditingResource.name,
                                    productId: isEditingResource.productId,
                                    productName: productName,
                                    resourceSplitId,
                                  });
                                } catch (error) {
                                  alert(error?.message || "Unable to save the resource");
                                  return;
                                }
                                const group =
                                  await api.resources.getResourceGroup(id);
                                setData(group);
                                doEditResource(null);
                              }}
                            >
                              save
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td>{resourceId}</td>
                            <td>{name}</td>
                            <td>{productName}</td>
                            <td
                              onClick={async () => {
                                if (
                                  !confirm(
                                    "are you sure to delete this resource?"
                                  )
                                ) {
                                  return;
                                }
                                await api.resources.removeResource(resourceId);
                                const group =
                                  await api.resources.getResourceGroup(id);
                                setData(group);
                              }}
                            >
                              remove
                            </td>
                            <td
                              onClick={async () => {
                                doEditResource({
                                  Id: resourceId,
                                  name: name,
                                  productId: productId,
                                  productName: productName,
                                  resourceSplitId,
                                });
                              }}
                            >
                              edit
                            </td>
                            <td></td>
                          </tr>
                        )
                    )}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td
                        onClick={async () => {
                          try {
                            await api.resources.addResource(x.id);
                          } catch (error) {
                            alert(error?.message || "Unable to add the resource");
                            return;
                          }
                          const group = await api.resources.getResourceGroup(
                            id
                          );
                          setData(group);
                        }}
                      >
                        add
                      </td>
                      <td></td>
                    </tr>
                  </table>
                  <br />
                </React.Fragment>
              ))}
              <span
                onClick={async () => {
                  try {
                    await api.resources.addSplit(data.group.id);
                  } catch (error) {
                    alert(error?.message || "Unable to add the split");
                    return;
                  }
                  const group = await api.resources.getResourceGroup(id);
                  setData(group);
                }}
              >
                Add split
              </span>
              </>
              )}
              <br />
              <br />
              {/* {
                  JSON.stringify(data)
                } */}
            </React.Fragment>
          ) : (
            "..loading..."
          )}
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

const ResourceGroup = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(ResourceGroupInternal)
  )
);

ResourceGroup.requiresLogin = true;
ResourceGroup.propTypes = { isLoggedIn: PropTypes.bool };

export default ResourceGroup;
